import { CancelIcon } from '@/react/components/icons/primitives';
import { UserFallbackIcon } from '@/react/components/icons/UserFallbackIcon';

import { useLiveAvatarUrl } from '../Sidebar/avatarEvents';
import type { SidebarUser } from '../Sidebar/SidebarUserProfile';
import { FOCUS_RING_CLASS, ITEM_LABEL_CLASS } from './constants';

interface MobileSidebarHeaderProps {
  user: SidebarUser;
  onClose: () => void;
}

function Avatar({ user }: { user: SidebarUser }) {
  const avatarUrl = useLiveAvatarUrl(user.avatarUrl);

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt=""
        width={80}
        height={80}
        className="h-20 w-20 flex-shrink-0 rounded-full object-cover"
      />
    );
  }
  return (
    <div className="flex h-20 w-20 flex-shrink-0 items-center justify-center rounded-full bg-dinnerplate-white-light">
      <UserFallbackIcon className="h-10 w-10 text-grey-light" aria-hidden="true" />
    </div>
  );
}

export function MobileSidebarHeader({ user, onClose }: MobileSidebarHeaderProps) {
  return (
    <div className="flex shrink-0 items-center justify-between border-b-thin border-grey-light bg-off-white px-6 pb-8 pt-safe-top">
      <div className="flex items-center gap-4" aria-label={`${user.name}, ${user.role}`}>
        <Avatar user={user} />
        <div className="flex flex-col items-start gap-2">
          <span className={`${ITEM_LABEL_CLASS} capitalize text-text-primary`}>{user.name}</span>
          <span className="whitespace-nowrap rounded-xs bg-dinnerplate-white-light px-2 py-1 text-xs font-semibold capitalize text-grey">
            {user.role.replace(/_/g, ' ')}
          </span>
        </div>
      </div>
      <button
        type="button"
        aria-label="Close menu"
        onClick={onClose}
        className={`flex size-16 flex-shrink-0 touch-manipulation items-center justify-center rounded-input border-thin border-dinnerplate-white hover:bg-dinnerplate-white-light ${FOCUS_RING_CLASS}`}
      >
        <CancelIcon className="h-5 w-5 text-text-primary" aria-hidden="true" />
      </button>
    </div>
  );
}